import Fetcher from "../utils/fetcher";

export class RedirectAlfaService {
    async redirect() {
        try {
            return await Fetcher<any>('/alfa_auth')
                .json();
        } catch (e: any) {
            throw new Error(e);
        }
    }
}
